import { render, staticRenderFns } from "./InscritosTextView.vue?vue&type=template&id=5e77c73a&scoped=true"
import script from "./InscritosTextView.vue?vue&type=script&lang=js"
export * from "./InscritosTextView.vue?vue&type=script&lang=js"
import style0 from "./InscritosTextView.vue?vue&type=style&index=0&id=5e77c73a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77c73a",
  null
  
)

export default component.exports